module.exports = __webpack_public_path__ + "gif_on.a03c6b9a76e0712682c87716ba5bcbfa.svg";